import {
  getLocalesAsArray,
  i18next,
  LanguageCode,
  Locale,
  useCurrentLocale,
  useTranslation,
} from '@framework/i18n';
import { Divider, Space } from 'antd';
import clx from 'classnames';
import { useCallback, useMemo } from 'react';
import styled from 'styled-components';
import { LanguageButton } from '../../ui/menu/LanguageButton';
import { MobileLanguageMenu } from './MobileLanguageMenu';

const StyledWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  .ant-space-item-split {
    z-index: 0;
  }
  .ant-space-item {
    z-index: 1;
  }
  /* padding-inline: 1rem; */
`;
const StyledDivider = styled(Divider)`
  margin: 0;
  min-height: 28px;
`;

const locales = getLocalesAsArray();
export interface ILanguageMenuProps {
  isMobile?: boolean | null;
}

export function LanguageMenu(props: ILanguageMenuProps) {
  const { isMobile } = props;
  const currentLanguage = useCurrentLocale();
  const { t } = useTranslation();

  const handleClick = useCallback((locale: Locale) => {
    i18next.changeLanguage(locale.tag);
    window.location.reload();
  }, []);

  const langNames = useMemo<Record<LanguageCode, string>>(
    () => ({
      it: t('lang-long-name.it', 'Italiano'),
      en: t('lang-long-name.en', 'Inglese'),
    }),
    [t],
  );

  if (isMobile) {
    return (
      <MobileLanguageMenu
        selected={currentLanguage}
        locales={locales}
        onSelected={handleClick}
      />
    );
  }
  return (
    <StyledWrapper>
      <Space
        size="large"
        role="navigation"
        aria-label={t(
          'layout.header.menu-di.scelta-lingua',
          'Menu di scelta lingua',
        )}
      >
        <Space
          size={0}
          align="center"
          split={
            !isMobile && <StyledDivider type="vertical" aria-hidden="true" />
          }
        >
          {locales.map(locale => (
            <LanguageButton
              className={clx({
                selected: currentLanguage.tag === locale.tag,
              })}
              key={locale.tag}
              disabled={currentLanguage.tag === locale.tag}
              onClick={() => handleClick(locale)}
              aria-label={t(
                'layout.header.menu-di.passa-alla-lingua',
                'Passa alla lingua {{langName}}',
                {
                  langName: langNames[locale.language],
                },
              )}
            >
              {locale.label}
            </LanguageButton>
          ))}
        </Space>
      </Space>
    </StyledWrapper>
  );
}
